// NOTE: MIME-type list duplicated in backend. Update in both places.
const lookup = Object.freeze({
  'web-images': [
    // JPG
    'image/jpeg',
    'image/pjpeg',
    // PNG
    'image/png',
    'image/x-png',
    'image/vnd.mozilla.apng',
    // GIF
    'image/gif',
    // WEBP
    'image/webp',
    // Standard HEIC
    'image/heic',
    // Apple's HEIF/HEIC for iPhone photos
    'image/heif',
    // AV1 Image File Format
    'image/avif',
  ],
  documents: [
    // PDF
    'application/pdf',
    // Word Doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
    'application/msword', // doc
    // PowerPoint
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
    'application/vnd.ms-powerpoint', // ppt
    // Excel
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
    'application/vnd.ms-excel.sheet.macroenabled.12', // xlsm
    'application/vnd.ms-excel', // xls
    // CSV
    'text/csv',
    // TXT
    'text/plain',
    'text/x-log',
  ],
});

const AttachmentService = {
  /**
   * Get list of mime-types we allow for the given type of files.
   *
   * Available type lists:
   *
   * - web-images
   * - documents
   *
   * Usage:
   *
   * buildAcceptMimeTypesList('web-images');
   * buildAcceptMimeTypesList('web-images', 'documents');
   *
   * @param {...String} types Variadic list of attachment types: web-images, documents
   * @returns {String} Mime-types comma-delimited
   */
  buildAcceptMimeTypesList: (...types) => {
    let accept = [];

    // Build list of given types
    for (let i = 0; i < types.length; i++) {
      let type = types[i];
      if (!lookup[type]) {
        throw new Error('Invalid accept type to build list of accept MIME-types');
      }

      accept = accept.concat(lookup[type]);
    }

    return accept.join(',');
  },
};

export default AttachmentService;
